/**
 * A directive that, when attached to input type="file", gives ng-model support.
 * Based on: https://github.com/ghostbar/angular-file-model
 * @returns {any} The FileModel directive.
 */
export function FileModelDirective() {

    return {
        restrict: "A",
        require: "ngModel",
        link: link
    };

    function link(scope, el, attr, ngModel) {
        if (el[0].tagName !== "INPUT" || el[0].type !== "file") {
            console.error("apexFileModel must be used as an attribute of input with type 'file'");
            return;
        }
        updateValidity();

        el.bind("change", function () {
            scope.$apply(function () {
                updateValidity();
                ngModel.$setViewValue(attr.multiple ? el[0].files : el[0].files[0]);
                ngModel.$render();
            });
        });

        function updateValidity() {
            ngModel.$setValidity("file", validateFile(el));
        }

        function validateFile() {
            return !el.prop("required") || el.val() !== "";
        }

        function onModelValueChange(file) {
            if (!file) {
                el.val(null)
            }
            return file;
        }

        ngModel.$formatters.push(onModelValueChange);
    }
}
